import qq from 'fineuploader';
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

function withProfileImageUploader() {
    // Fineuploader: Initialize Fineuploader on uploader-element
    this.initializeUploader = function() {
        const successParams = {};

        successParams[this.attr.csrfParam] = this.attr.csrfToken;

        this.select('uploaderSelector')
            .fineUploaderS3({
                // Control debug output via html flag
                debug: this.select('uploaderSelector').data('uploader-debug'),

                // Specify template element
                template: this.select('uploaderTemplateSelector'),

                // If browser/device is not able to generate previews without
                // upload, use autoUpload feature
                autoUpload: !qq.supportedFeatures.imagePreviews,

                // Limit files to specific extensions
                validation: {
                    allowedExtensions: ['jpg', 'gif', 'png'],
                },

                showMessage() {
                    // TODO: Update as soon as error-messages are available
                    // - Supress Fineuploader alerts
                    // - Currently everything is handled in error-callback
                },

                // Request settings
                request: {
                    endpoint: this.select('uploaderSelector').data('uploader-endpoint'),
                    accessKey: this.select('uploaderSelector').data('uploader-access-key'),
                },

                // Signature settings
                signature: {
                    endpoint: this.select('uploaderSelector').data('uploader-signature-endpoint'),
                    customHeaders: { 'X-CSRF-Token': this.attr.csrfToken },
                },

                // Success endpoint
                uploadSuccess: {
                    endpoint: this.select('uploaderSelector').data('uploader-success-endpoint'),
                    params: successParams,
                },

                // Provide iframe support for old browsers/devices
                iframeSupport: {
                    localBlankPagePath: this.select('uploaderSelector').data(
                        'uploader-success-blank-url'
                    ),
                },
            })

            // Image was selected by user (from file-system)
            .on('submitted', (event, id) => {
                // If image previews are possible show them
                if (qq.supportedFeatures.imagePreviews) {
                    this.trigger(`${this.attr.eventPrefix}SubmittedToUploader`, {
                        imageId: id,
                    });
                } else {
                    // If image previews are not possible, start upload
                    this.trigger(`${this.attr.eventPrefix}AutomaticUploadStarted`);
                }
            })

            // Upload to S3 started
            .on('upload', () => {
                this.trigger(`${this.attr.eventPrefix}UploadStarted`);
            })

            // Upload is complete
            .on('complete', (event, id, name, responseJSON) => {
                this.trigger(`${this.attr.eventPrefix}UploadComplete`, {
                    url: responseJSON.imageUrl,
                });

                // Make sure that error messages are only hidden if upload
                // succeeded (e.g. 403 is complete, but not successful)
                if (responseJSON.success) {
                    this.hideErrorMessage();
                }
            })

            // Something went wrong
            .on('error', (event, id, name, errorReason, xhr) => {
                this.trigger(`${this.attr.eventPrefix}UploadFailed`, {
                    id,
                    name,
                    errorReason,
                    xhr,
                    url: this.attr.backupUrl,
                });
            });
    };

    // Fineuploader: Upload previewed file
    this.uploadSelectedImage = function() {
        const saveButtonEnabled = !this.select('saveButtonSelector').attr('disabled');
        const submittedUploads = this.select('uploaderSelector').fineUploader('getUploads', {
            status: qq.status.SUBMITTED,
        });

        if (saveButtonEnabled && submittedUploads.length) {
            this.select('uploaderSelector').fineUploader('uploadStoredFiles');
        }
    };

    // Fineuploader: Cancel previewed file and restore original
    this.cancelSelectedImage = function() {
        const cancelButtonEnabled = !this.select('cancelButtonSelector').attr('disabled');

        if (cancelButtonEnabled) {
            this.select('uploaderSelector').fineUploader('cancelAll');
            this.trigger(`${this.attr.eventPrefix}UploadCanceled`, {
                url: this.attr.backupUrl,
            });
        }
    };

    // Fineuploader: Draw thumbnail to invisible canvas and get data-url
    this.drawThumbnailOnCanvas = function(event, data) {
        this.select('uploaderSelector')
            .fineUploader(
                'drawThumbnail',
                data.imageId,
                this.select('canvasSelector'),
                this.attr.previewImageWidth
            )
            .then(canvas => {
                this.trigger(`${this.attr.eventPrefix}DrawnOnCanvas`, {
                    url: canvas.toDataURL(),
                });
            });
    };

    // Set background-url to cover-image as inline-style
    this.setBackgroundUrl = function(event, data) {
        if (data.url) {
            if (this.select('originalImageSelector')[0].nodeName === 'IMG') {
                this.select('originalImageSelector').prop('src', data.url);
            } else {
                this.select('originalImageSelector').css('background-image', `url(${data.url})`);
            }
        }
    };

    // Disable SAVE button, when upload was triggered
    this.disableSaveButton = function() {
        this.select('saveButtonSelector')
            .attr('disabled', true)
            .addClass('button--disabled');

        this.select('saveButtonLabelSelector')
            .attr('data-original-text', this.select('saveButtonLabelSelector').html())
            .html(this.select('saveButtonLabelSelector').data('active-text'));

        this.addSpinner(this.select('saveButtonInnerSelector'));
    };

    // Disable CANCEL button when upload was triggered
    this.disableCancelButton = function() {
        this.select('cancelButtonSelector')
            .attr('disabled', true)
            .addClass('button--disabled');
    };

    // Disable EDIT COVER button when autoupload was startedd
    this.disableEditButton = function() {
        this.select('editButtonSelector')
            .attr('disabled', true)
            .addClass('button--disabled');
        this.addSpinner(this.select('editButtonSelector'));
    };

    // (Re)enable SAVE button when upload was successful
    this.enableSaveButton = function() {
        this.select('saveButtonSelector')
            .removeAttr('disabled')
            .removeClass('button--disabled');

        this.select('saveButtonLabelSelector').html(
            this.select('saveButtonLabelSelector').data('original-text')
        );

        this.removeSpinner(this.select('saveButtonInnerSelector'));
    };

    // (Re)enable CANCEL button when upload was successful
    this.enableCancelButton = function() {
        this.select('cancelButtonSelector')
            .removeAttr('disabled')
            .removeClass('button--disabled');
    };

    // (Re)enable EDIT COVER button when upload was successful
    this.enableEditButton = function() {
        this.select('editButtonSelector')
            .removeAttr('disabled')
            .removeClass('button--disabled');
        this.spinner = null;
        this.$node.find('.spinner').remove();
    };

    // Show confirmation wrapper
    this.showConfirmWrapper = function() {
        this.select('confirmEditWrapperSelector').attr('data-active', true);
    };

    // Hide confirmation wrapper
    this.hideConfirmWrapper = function() {
        this.select('confirmEditWrapperSelector').removeAttr('data-active');
    };

    // Activate page-overlay by setting attribute on page-wrapper
    this.showOverlay = function() {
        this.$node.attr('data-image-edit-active', true);
    };

    // De-activate page-overlay by removing attribute on page-wrapper
    this.hideOverlay = function() {
        this.$node.removeAttr('data-image-edit-active');
    };

    // Show error message if something went wrong
    this.showErrorMessage = function(e, data) {
        // TODO: Update as soon as error-messages are available
        this.select('errorMessageBodySelector').text(data.errorReason);
        this.select('errorMessageSelector').attr('data-active', true);
    };

    // Hide error message
    this.hideErrorMessage = function() {
        this.select('errorMessageSelector').removeAttr('data-active');
    };

    this.addSpinner = function($element) {
        const $spinner = $('<span class="button__icon"><span class="spinner"/></span>');
        $element.append($spinner);
    };

    this.removeSpinner = function($element) {
        $element.remove('.button__icon');
    };
}

export default withProfileImageUploader;



// WEBPACK FOOTER //
// ./src/js/mixins/with-profile-image-uploader.js